// extracted by mini-css-extract-plugin
export default {"imgWarp":"avatarIcon_imgWarp__dJTae","iconWrap":"avatarIcon_iconWrap__3N0xn","image":"avatarIcon_image__Fkg7a","icon":"avatarIcon_icon__a0c9w"};